import { useState, useEffect } from "react";

const useTimer = (
    time: number
): [timeParser: string, finish: boolean, handleSetNewTime: (value: number) => void] => {
    const [newTime, setNewTime] = useState(time ?? 0);
    const toTimeParse = `${
        Math.floor(newTime / 60) < 10 ? `0${Math.floor(newTime / 60)}` : Math.floor(newTime / 60)
    }:${newTime % 60 < 10 ? `0${newTime % 60}` : newTime % 60}`;

    const [timeParse, setTimeParse] = useState(toTimeParse);
    const [finish, setFinish] = useState(false);

    useEffect(() => {
        if (newTime >= 0) {
            setTimeout(() => {
                setNewTime(newTime - 1);
                setTimeParse(toTimeParse);
                setFinish(false);
            }, 1000);
        }
        if (newTime === 0) setTimeout(() => setFinish(true), 1000);
    }, [newTime, toTimeParse]);
    return [timeParse, finish, setNewTime];
};

export default useTimer;
